module.exports = __webpack_public_path__ + "media/reject-change.944d584e.svg";